export default {"src":"/_next/static/media/select-slot.c3ebd0be.svg","height":47,"width":46,"blurWidth":0,"blurHeight":0};